import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useEligibleServicesModalStore } from '../stores/useEligibleServicesModal.store';

import useEligibleServices from './useEligibleServices';

const useEligibleServicesLine = (policyId?: number | string) => {
  const { t } = useTranslation();
  const { data, isLoading } = useEligibleServices(policyId);
  const handleOpenModal = useEligibleServicesModalStore((state) => state.handleChangeVisibility);

  const displayLabel = useMemo(() => {
    const label = `${t('Eligible services covered by this account')}: ${data.serviceNames.slice(0, 3).join(', ')}`;

    return data.extraCount > 0 ? `${label},…` : label;
  }, [t, data.serviceNames, data.extraCount]);

  return {
    displayLabel,
    categories: data.categories,
    extraCount: data.extraCount,
    total: data.total,
    isLoading,
    handleOpenModal: () => handleOpenModal(true),
  };
};

export default useEligibleServicesLine;
